import { R } from "apparatus/library/common";
import { Shape } from "paper";
export class Splint {
    render(appearance) {
        let width = appearance.width;
        let length = appearance.length;
        let graphic = Shape.Rectangle(R(0, 0, width, length), width / 2)
            .withFill("#ddc292")
            .withStroke("thinner", "#b69660");
        return { graphic: graphic, hitShape: graphic.bounds.expand(15).toShape() };
    }
}
Splint.properties = {
    label: "Wooden Splint",
    defaultAppearance: {
        length: 140,
        width: 8
    },
    appearanceSpecs: [
        {
            spec: "slider", key: "length", label: "Length",
            min: 100, max: 180
        },
        {
            spec: "slider", key: "width", label: "Width",
            min: 5, max: 12,
        }
    ],
};
